<div class="flex flex-col gap-3">
  <div class="flex items-stretch gap-1.5 py-2">
    @for (grade of grades; track grade) {
      <button
        type="button"
        class="flex min-h-[70px] flex-1 flex-col overflow-hidden rounded-xl border-2 shadow-sm transition-all duration-300"
        [style.borderColor]="isSelected(grade) ? getGradeColor(grade) : 'var(--color-neutral-3)'"
        [style.backgroundColor]="getBackgroundColor(grade)"
        [ngClass]="{
          'ring-surface-default z-10 -translate-y-3': isSelected(grade),
          'opacity-40 hover:opacity-100': value() && !isSelected(grade),
          'cursor-pointer': !readonly(),
          'pointer-events-none cursor-default': readonly(),
        }"
        (click)="select(grade)"
      >
        <!-- Dynamic colored accent bar for unselected items -->
        <div
          class="h-2 w-full transition-all duration-300"
          [style.backgroundColor]="getGradeColor(grade)"
          [class.opacity-0]="isSelected(grade)"
        ></div>

        <div
          class="flex flex-1 flex-col items-center justify-center p-1 font-black"
          [style.color]="getTextColor(grade)"
        >
          <span class="text-2xl leading-none" [style.textShadow]="getTextOutline(grade)">{{ grade }}</span>
          <span class="mt-0.5 text-[9px] opacity-70">{{ ranges()[grade] }}</span>
        </div>
      </button>
    }
  </div>

  @if (description()) {
    <div class="flex justify-between px-2 text-[10px] font-black tracking-[0.2em] text-neutral-10 uppercase">
      <span>{{ description().low }}</span>
      <span>{{ description().high }}</span>
    </div>
  }
</div>
